<script>
import appConfig from '@src/app.config';
import { authMethods } from '@state/helpers'
import Layout from '@layouts/child';
import PageHeader from '@components/page-header';

import { PageViewsTable } from 'coryallen-page-views';
import { ListingsTable, ListingsForm } from 'coryallen-listings';

import UsersForm from './UsersForm';

import { CommunicationsTable } from 'coryallen-communications';

export default {
  page: {
    title: 'Contacts',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, UsersForm, PageViewsTable, ListingsTable, ListingsForm, CommunicationsTable },
  data() {
    return {
      title: 'Contacts',
      items: [
        { text: appConfig.title, to: '/', },
        { text: 'Contacts', to: '/contacts', },
        { text: '', active: true, },
      ],
      dsbl_btn: false,

      tabIndex: 0,

      tempAvatar: '',

      loading: true,
      item: [],
      filters: {
        paginate: 1,
        page: 1,
        total: 0,
        wheres: {
          id: this.$route.params.id
        },
        withs: {
          // lead_recipients: {total: 0},
          // lead_types: {total: 0}
        },
      },

      pageviews_loading: true,
      pageviews_filters: {
        paginate: 50,
        page: 1,
        total: 0,
        wheres: {}
      },

      listings_loading: true,
      listings_filters: {
        wheres: { user_id: this.$route.params.id, },
      },

      communications_loading: true,
      communications_filters: {
        paginate: 50,
        page: 1,
        total: 0,
        types: ['Note', 'Activity'],
        only: '',
        onable_id: this.$route.params.id,
        onable_type: 'App\\User',
        // byable_id: this.$route.params.id,
        // byable_type: 'App\\User',
      },
    }
  },
  created() {
    this.tabIndex = parseInt(window.location.hash.replace('#',''), 10);
    this.fetchData();
  },
  methods: {
    ...authMethods,
    fetchData() {
      this.loading = true;
      this.$http.get('/api/users/fetch', {params: this.filters}).then(res => {
        // console.log(res);
        if(res.data.data.length == 1) {
          if(res.data.data[0].email_verified_at) { res.data.data[0].email_verified_at_placeholder = "Yes"; } else { res.data.data[0].email_verified_at_placeholder = "No"; }
          this.item = res.data.data[0];
          this.title = this.items[2].text = this.item.name;
          // this.inboxs_filters.wheres.email = this.item.email;
        } else {
          $this.$noty.warning("Content could not be found.");
          this.$router.push('/contacts');
        }
        this.loading = false;
      }).catch(res => { this.popupErrors(res); this.loading = false; });
    },
    update_user() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;

      this.$http.put('/api/users/update', this.item).then(res => {
        // console.log(res);
        this.fetchData();
        this.$noty.success("Changes have been saved");
        this.dsbl_btn = false;
      }).catch(res => { this.popupErrors(res); this.dsbl_btn = false; });
    },
    delete_user() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;
      if(!this.item.id) { this.$noty.warning('ID not found'); this.dsbl_btn = false; return; }

      let randomid = 'id'+(Math.random() + 1).toString(36).substring(7);
      var n = new Noty({
        timeout: false,
        modal: true,
        type: 'alert', // alert, success, warning, error, info
        layout: 'center', // top, topLeft, topCenter, topRight, center, centerLeft, centerRight, bottom, bottomLeft, bottomCenter, bottomRight
        closeWith: ['button'], // click, button
        text: "Are you sure you want to delete this user?",
        buttons: [
          Noty.button('<span id="'+randomid+'_spin" class="d-none spinner-border spinner-border-sm"></span> DELETE', 'btn btn-danger px-4 float-right ml-2', notyres => {
            var btn = document.getElementById(randomid), spin = document.getElementById(randomid+"_spin"), btnno = document.getElementById(randomid+"_no");
            if(btn.disabled) { this.$noty.warning('Disabled'); return; } btn.disabled = btnno.disabled = true; spin.classList.remove("d-none");
            this.$http.delete('/api/users/delete/'+this.item.id).then(res => {
              // console.log(res);
              this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none");
              n.close();
              this.$router.push('/contacts');
            }).catch(res => { this.popupErrors(res); this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none"); });
          }, {id: randomid, 'data-status': 'ok'}),
          Noty.button('CANCEL', 'btn btn-light px-4 mr-2', notyres => {
            n.close();
          }, {id: randomid+'_no', 'data-status': 'ok'}),
        ]
      }).show().on('onClose', () => { this.dsbl_btn = false; });
    },
    send_verification() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;
      if(!this.item.id) { this.$noty.warning('ID not found'); this.dsbl_btn = false; return; }

      let randomid = 'id'+(Math.random() + 1).toString(36).substring(7);
      var n = new Noty({
        timeout: false,
        modal: true,
        type: 'alert', // alert, success, warning, error, info
        layout: 'center', // top, topLeft, topCenter, topRight, center, centerLeft, centerRight, bottom, bottomLeft, bottomCenter, bottomRight
        closeWith: ['button'], // click, button
        text: "Send an email containing email verification instructions to this user?",
        buttons: [
          Noty.button('<span id="'+randomid+'_spin" class="d-none spinner-border spinner-border-sm"></span> SEND', 'btn btn-primary px-4 float-right ml-2', notyres => {
            var btn = document.getElementById(randomid), spin = document.getElementById(randomid+"_spin"), btnno = document.getElementById(randomid+"_no");
            if(btn.disabled) { this.$noty.warning('Disabled'); return; } btn.disabled = btnno.disabled = true; spin.classList.remove("d-none");
            this.$http.post('/api/users/sendverification', {id: this.item.id}).then(res => {
              // console.log(res);
              this.$noty.success("Verification instructions have been sent.");
              this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none");
              n.close();
            }).catch(res => { this.popupErrors(res); this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none"); });
          }, {id: randomid, 'data-status': 'ok'}),
          Noty.button('CANCEL', 'btn btn-light px-4 mr-2', notyres => {
            n.close();
          }, {id: randomid+'_no', 'data-status': 'ok'}),
        ]
      }).show().on('onClose', () => { this.dsbl_btn = false; });
    },
    send_password() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;
      if(!this.item.id) { this.$noty.warning('ID not found'); this.dsbl_btn = false; return; }

      let randomid = 'id'+(Math.random() + 1).toString(36).substring(7);
      var n = new Noty({
        timeout: false,
        modal: true,
        type: 'alert', // alert, success, warning, error, info
        layout: 'center', // top, topLeft, topCenter, topRight, center, centerLeft, centerRight, bottom, bottomLeft, bottomCenter, bottomRight
        closeWith: ['button'], // click, button
        text: "Send password reset instructions to this user?",
        buttons: [
          Noty.button('<span id="'+randomid+'_spin" class="d-none spinner-border spinner-border-sm"></span> SEND', 'btn btn-primary px-4 float-right ml-2', notyres => {
            var btn = document.getElementById(randomid), spin = document.getElementById(randomid+"_spin"), btnno = document.getElementById(randomid+"_no");
            if(btn.disabled) { this.$noty.warning('Disabled'); return; } btn.disabled = btnno.disabled = true; spin.classList.remove("d-none");
            this.$http.post('/api/users/sendpassword', {id: this.item.id}).then(res => {
              // console.log(res);
              this.$noty.success("Password reset instructions have been sent.");
              this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none");
              n.close();
            }).catch(res => { this.popupErrors(res); this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none"); });
          }, {id: randomid, 'data-status': 'ok'}),
          Noty.button('CANCEL', 'btn btn-light px-4 mr-2', notyres => {
            n.close();
          }, {id: randomid+'_no', 'data-status': 'ok'}),
        ]
      }).show().on('onClose', () => { this.dsbl_btn = false; });
    },
    updateTempAvatar(e) {
      this.tempAvatar = e;
    },
    saveAvatar() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;
      if(this.tempAvatar) {
        this.$http.post('/api/users/updateavatar', {id: this.item.id, avatarData: this.tempAvatar}).then(res => {
          // console.log(res);
          if(res.data && res.data.avatar) {
            this.item.avatar = res.data.avatar;
            this.validate();
          }
          this.$noty.success("Avatar has been updated");
          this.$refs.modal_change_avatar.hide();
          this.dsbl_btn = false;
        }).catch(res => { this.dsbl_btn = false; this.popupErrors(res); });
      } else {
        this.$noty.warning("Avatar data is empty. Failed to save.");
        this.dsbl_btn = false;
      }
    },
    deleteAvatar() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;

      let randomid = 'id'+(Math.random() + 1).toString(36).substring(7);
      var n = new Noty({
        timeout: false,
        modal: true,
        type: 'alert', // alert, success, warning, error, info
        layout: 'center', // top, topLeft, topCenter, topRight, center, centerLeft, centerRight, bottom, bottomLeft, bottomCenter, bottomRight
        closeWith: ['button'], // click, button
        text: "Are you sure you want to delete this avatar?",
        buttons: [
          Noty.button('<span id="'+randomid+'_spin" class="d-none spinner-border spinner-border-sm"></span> DELETE', 'btn btn-danger px-4 float-right ml-2', notyres => {
            var btn = document.getElementById(randomid), spin = document.getElementById(randomid+"_spin"), btnno = document.getElementById(randomid+"_no");
            if(btn.disabled) { this.$noty.warning('Disabled'); return; } btn.disabled = btnno.disabled = true; spin.classList.remove("d-none");
            this.$http.post('/api/users/deleteavatar', {id: this.item.id}).then(res => {
              // console.log(res);
              this.item.avatar = '';
              this.validate();
              this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none");
              n.close();
            }).catch(res => { this.popupErrors(res); this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none"); });
          }, {id: randomid, 'data-status': 'ok'}),
          Noty.button('CANCEL', 'btn btn-light px-4 mr-2', notyres => {
            n.close();
          }, {id: randomid+'_no', 'data-status': 'ok'}),
        ]
      }).show().on('onClose', () => { this.dsbl_btn = false; });
    },
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <b-tabs class="nav-bordered header-nav hide-content" lazy v-model="tabIndex">
      <b-tab><template v-slot:title><span class="spinner-border spinner-border-sm" v-if="listings_loading"></span> Listings</template></b-tab>
      <b-tab><template v-slot:title><span class="spinner-border spinner-border-sm" v-if="pageviews_loading"></span> Page Views</template></b-tab>
      <b-tab><template v-slot:title><span class="spinner-border spinner-border-sm" v-if="communications_loading"></span> Notes & Activities</template></b-tab>
      <b-tab><template v-slot:title><span class="spinner-border spinner-border-sm" v-if="loading"></span> Details</template></b-tab>
    </b-tabs>

    <div v-if="item.id">

      <div class="row mt-4 set-sm-375">
        <div class="col-lg-4">
          <div class="card-box border text-center position-relative p-4 _box-shadow-0-1-4-b-2">
            <div v-if="!item.email_verified_at" class="ribbon ribbon-danger float-right" v-tippy content="Email has not been verified by the account owner.">Not verified</div>
            <div v-if="item.roles.filter(e => e.title === 'Dev').length > 0" class="ribbon-two ribbon-two-danger"><span>Dev</span></div>
            <div v-else-if="item.roles.filter(e => e.title === 'Admin').length > 0" class="ribbon-two ribbon-two-success"><span>Admin</span></div>
            <div class="pb-3" @click="$refs.modal_change_avatar.show()">
              <img v-if="item.avatar" :src="formatImage(item.avatar)" class="w-100 rounded">
              <avatar v-else :username="item.name" :size="100" :rounded="false" class="w-100 h-100 rounded"  style="aspect-ratio: 1 / 1;"></avatar>
            </div>
            <div class="text-center">
              <h4 v-if="item.name" class="font-weight-900">{{item.name}}</h4>
              <p v-if="item.email" class="small _lh-15">{{item.email}}</p>
              <p v-if="item.phone" class="small _lh-15">{{formatPhone(item.phone)}}</p>
            </div>

            <b-modal ref="modal_change_avatar" centered size="md" title="Edit your avatar" :no-close-on-backdrop="true" :no-close-on-esc="true" :hide-footer="true">
              <b-form @submit.prevent="saveAvatar">
                <div class="p-3">
                  <w-image-cropper @updateimg="updateTempAvatar"></w-image-cropper>
                </div>
                <footer class="modal-footer modal-footer-custom">
                  <div class="mr-auto">

                  </div>
                  <button type="button" class="btn btn-light" @click="$refs.modal_change_avatar.hide()" :disabled="dsbl_btn"><Icon icon="ri:close-line"></Icon> Cancel</button>
                  <button type="submit" class="btn btn-primary" :disabled="dsbl_btn"><span v-if="dsbl_btn" class="spinner-border spinner-border-sm"></span><Icon v-else icon="ri:save-line"></Icon> Save</button>
                </footer>
              </b-form>
            </b-modal>

          </div>

          <div class="mb-4 btn-group-vertical w-100">
            <button type="button" class="btn btn-white text-gray-900 text-left mb-1" @click="$refs.modal_change_avatar.show()" :disabled="dsbl_btn"><Icon icon="ri:upload-cloud-line" class="mr-1"></Icon> Change avatar</button>
            <button type="button" class="btn btn-white text-gray-900 text-left mb-1" @click="deleteAvatar()" :disabled="dsbl_btn"><Icon icon="ri:delete-bin-7-line" class="mr-1"></Icon> Delete avatar</button>
            <button v-if="!item.email_verified_at" type="button" class="btn btn-white text-gray-900 text-left mb-1" v-tippy content="Send an email containing email verification instructions to this person." @click="send_verification()" :disabled="dsbl_btn"><Icon icon="ri:mail-send-line" class="mr-1"></Icon> Send verification</button>
            <button v-if="item.email_verified_at" type="button" class="btn btn-white text-gray-900 text-left mb-1" v-tippy content="Send an email with password reset instructions to this person." @click="send_password()" :disabled="dsbl_btn"><Icon icon="ri:mail-send-line" class="mr-1"></Icon> Send password reset</button>
          </div>

          <div class="card-box">
            <h5 class="section-header mb-3"><Icon icon="ri:book-2-line"></Icon> About :</h5>
            <div class="table-responsive">
              <table class="table table-sm table-px-0">
                <tbody>
                  <tr><th class="text-nowrap border-0"><label>Full name :</label></th><td class="border-0 small">{{item.name}}</td></tr>
                  <tr><th class="text-nowrap"><label>Website :</label></th><td class="small">{{item.website}}</td></tr>
                  <tr><th class="text-nowrap"><label>Last active :</label></th><td class="small" v-tippy :content="moment(item.last_active).format('lll')">{{moment(item.last_active).fromNow()}}</td></tr>
                  <tr><th class="text-nowrap"><label>Created on :</label></th><td class="small" v-tippy :content="moment(item.created_at).format('lll')">{{moment(item.created_at).fromNow()}}</td></tr>
                  <tr v-if="item.roles && item.roles.length">
                    <th class="text-nowrap"><label>Roles :</label></th>
                    <td class="">
                      <span v-for="(role, index2) in item.roles" :key="role.id" class="px-1 d-inline-block small bg-gray-100 border rounded mr-1 mb-1">{{role.title}}</span>
                    </td>
                  </tr>
                  <tr v-if="item.lead_recipients && item.lead_recipients.length">
                    <th class="text-nowrap"><label>Lead recipients :</label></th>
                    <td class="">
                      <span v-for="(recip, recip_i) in item.lead_recipients" :key="recip.id" class="px-1 d-inline-block small bg-gray-100 border rounded mr-1 mb-1">{{recip.name}}</span>
                    </td>
                  </tr>
                  <tr v-if="item.lead_types && item.lead_types.length">
                    <th class="text-nowrap"><label>Lead types :</label></th>
                    <td class="">
                      <span v-for="(type, type_i) in item.lead_types" :key="type.id" class="px-1 d-inline-block small bg-gray-100 border rounded mr-1 mb-1">{{type.name}}</span>
                    </td>
                  </tr>
                  <tr v-if="item.ip_addresses && item.ip_addresses.length">
                    <th class="text-nowrap"><label>IP addresses :</label></th>
                    <td class="">
                      <span v-for="(ip, ip_i) in item.ip_addresses" :key="ip_i" class="px-1 d-inline-block small bg-gray-100 border rounded mr-1 mb-1">{{ip}}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <button v-if="hasRole(['Dev','Admin'])" type="button" class="btn btn-block btn-outline-danger" @click="delete_user" :disabled="dsbl_btn"><Icon icon="ri:delete-bin-7-line" /> Delete Contact</button>
        </div>
        <div class="col-lg-8">

          <div v-show="tabIndex == 0">

            <div class="row">
              <div class="col-12">
                <div class="card-box p-0 position-relative">
                  <ListingsTable ref="ListingsTable" :changefilters="listings_filters" @loadchange="(e) => {listings_loading = e;}"></ListingsTable>
                </div>
              </div>
            </div>

          </div>

          <div v-show="tabIndex == 1">
            <div class="card-box p-0 position-relative">
              <transition name="fade">
                <div class="ribbon-two ribbon-two-primary" :key="1" v-if="pageviews_loading"><span><i class="spinner-border spinner-border-sm"></i></span></div>
              </transition>
              <div class="row p-3">
                <div class="col-lg-8">
                  <div class="form-inline">
                    <button type="button" @click="$refs['PageViewsTable'].fetchData()" class="btn btn-light mr-2 mb-2"><Icon icon="ri:refresh-line"></Icon></button>
                    <div class="form-group">
                      <select class="form-control" v-model="pageviews_filters.paginate">
                        <option value="50">Per page: (50)</option>
                        <option value="100">Per page: (100)</option>
                        <option value="250">Per page: (250)</option>
                        <option value="500">Per page: (500)</option>
                        <option value="750">Per page: (750)</option>
                        <option value="1000">Per page: (1000)</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="text-lg-right mt-3 mt-lg-0">
                    
                  </div>
                </div>
              </div>
              <PageViewsTable v-if="item.id" ref="PageViewsTable" :filters="pageviews_filters" :theuser="item" @loadchange="(e) => {pageviews_loading = e}"></PageViewsTable>
            </div>
          </div>

          <div v-show="tabIndex == 2">
            <div class="">
              <CommunicationsTable ref="CommunicationsTable" :filters="communications_filters" :user="user" :name="'name'" @loadchange="(e) => {communications_loading = e}"></CommunicationsTable>
            </div>
          </div>

          <div v-show="tabIndex == 3">
            <div class="card-box">
              <b-form @submit.prevent="update_user">
                <UsersForm :item="item"></UsersForm>
                <div class="border-top border-light mt-5 pt-3 text-right">
                  <button type="submit" class="btn btn-success" :disabled="dsbl_btn"><span v-if="dsbl_btn" class="spinner-border spinner-border-sm"></span><Icon v-else icon="ri:save-line" /> Save</button>
                  <div class="clearfix"></div>
                </div>
              </b-form>
            </div>
          </div>

        </div>
      </div>

    </div>
  </Layout>
</template>
